/**
 * Legacy redirect: /profile → /admin/settings.
 * @file src/web/features/main/pages/profile.tsx
 *
 * Profile management merged into the Settings page — the professional profile and the
 * new "Change password" card both live under /admin/settings now. This route
 * is kept as a redirect so the header's "Profile" menu item and any old links
 * or bookmarks land on Settings instead of 404-ing. (`/settings` is not a real
 * route; the settings page is served at /admin/settings.)
 */

import { Navigate } from 'react-router-dom';

export default function MainProfilePage() {
  return <Navigate to="/admin/settings" replace />;
}
